import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

import DBoxMenuButton from './dBoxMenuButton.vue';
// TopRightMenu new Props - HTML/Mode

@Component({
  name: 'DBox'
})
export default class DBox extends Vue {
  @Prop({ required: true }) id;
  @Prop() sid;
  @Prop({ default: true }) addButton;
  @Prop({ default: false }) searchButton;
  @Prop({ default: false }) expandable;
  @Prop({ default: false }) defaultExpandState;
  @Prop({ default: "show_more_information" }) expandButtonLabel;
  @Prop({ default: "show_less_information" }) collapseButtonLabel;
  @Prop({ default: false }) addLink;
  @Prop({ default: false }) addInfo;
  @Prop({ default: false, type: Boolean }) searchFlag;
  @Prop({ default: false, type: Boolean }) noSeparator;

  @Prop({ default: '' }) addInfoLabel;
  @Prop({ default: 'Add' }) addLinkLabel;
  @Prop({ default: 'Add' }) tips;
  @Prop({ type: Array, default: () => [] }) rightMenu;
  @Prop({ type: Array, default: () => [] }) leftMenu;
  @Prop({ type: Array, default: () => [] }) topRightMenu;
  @Prop({ type: Array, default: () => [] }) badgeButtons;

  @Prop({ type: String, default: () => "static/icons/lupe-blue-invert.svg" }) searchIcon;
  @Prop({ type: String, default: () => "static/icons/lupe-blue.svg" }) searchIconAlt;

  @Watch('sid')
  onDefaultExpandStateChange(to, from) {
    if (to !== from) {
      this.syncExpandState();
    }
  }


  onAddOptionClick() {
    this.$emit('add_click', true);
    this.$emit('addClick', true);
  }
  onSearchClick() {
    this.$emit('searchClick');
  }
  onRightMenuClick(menu) {
    this.$emit('menuClick', menu.value);
  }
  onLeftMenuClick(menu) {
    this.$emit('menuClick', menu.value);
  }
  onDboxTopRightMenuClick(menu) {
    this.$emit('menuClick', menu.value);
  }
  onBadgeClick(menu) {
    this.$emit('badgeClick', menu.value);
  }

  get showLeftButton() {
    return this.addLink || this.expandable || (this.leftMenu && this.leftMenu.length > 0);
  }

  dboxTitleAddButton(h) {
    return (<img
      onKeyUp={e => { }}
      onKeyDown={e => { }}
      onKeyPress={e => { }}
      onClick={this.onAddOptionClick}
      src="static/icons/add-icon.svg"
      class="dt-icon v4"
      alt="Add Group"
      title="Add Group"
    />)
  };
  dboxSearchButton(h) {
    return (
      <div class="dt-icon-container">
        <img
          onClick={this.onSearchClick}
          onKeyUp={e => { }}
          onKeyDown={e => { }}
          onKeyPress={e => { }}
          src={this.searchFlag ? this.searchIcon : this.searchIconAlt}
          alt={this.$t('search')}
          class="dt-icon v4"
          style={{
            opacity: this.searchFlag ? 1 : undefined,
            cursor: 'pointer'
          }}

        />
      </div>
    )
  };
  dboxTopRightMenuButton(h, menu) {
    if (menu.html) {
      return <DBoxMenuButton menu={menu} />
    }
    return (<img
      onClick={e => this.onDboxTopRightMenuClick(menu)}
      onKeyUp={e => { }}
      onKeyDown={e => { }}
      onKeyPress={e => { }}
      src={`static/icons/${menu.icon}`}
      class="dt-icon v4 nop"
      style={menu.style || { cursor: 'pointer' }}
      alt={menu.text}
      title={menu.text}
    />)
  };

  showAddLinkButton(h) {
    return this.addInfo ? (<p
      class="v3 c5"
      style="margin: 8px; font-weight: inherit"

    >
      {this.addInfoLabel}
    </p>) : (<button
      type='button'
      onClick={this.onAddOptionClick}
      style="margin: 8px; font-weight: inherit;"
      class="dt-button v3 c5 txtov"
    >
      + {this.addLinkLabel}
    </button>);
  };


  showInfoLink(h) {
    return (<p
      style="margin: 8px; font-weight: inherit"
      class="dt-button v3 c5 txtov"

    >
      {this.addLinkLabel}
    </p>);
  };

  createLeftMenuButton(h, menu) {

    if (menu.label) {
      return <p
        class="v3 c5"
        style="margin: 8px; font-weight: inherit; color: var(--text-5)"
       
      >
        {menu.text}
      </p>
    }
    return (<button
      type='button'
      onClick={e => this.onLeftMenuClick(menu)}
      style="margin: 8px; font-weight: inherit"
      class={`dt-button txtov ${menu.buttonStyle === 5 ? 'v5 s8' :menu.buttonStyle === 1?'v3 c6' : 'v3 c5'} `}
    >
      {menu.text}
    </button>);
  };

  expandState = false;
  showExpandButton(h) {
    return (<button
      type='button'
      onClick={e => {
        this.expandState = !this.expandState;
        this.$parent.$emit('expand', this.expandState);
        // console.log({ "this.$parent.$parent": this.$parent.$parent.$el });
        const boxWidgetElement = this.$el.closest('div.box-widget');

        const gridBoxElement = this.$el.closest('div.dt-grid-box');
        // console.log({ "boxWidgetElement": boxWidgetElement });

        if (boxWidgetElement) {
          boxWidgetElement.__vue__.toggleExpandCollapse(this.expandState);
          // throw Error('Box Widget Parent Not found. Please Put the DBox Component Inside a Valid BoxWidget Component + Inside a Valid Vue Grid Layout Item Component.');
          // return;
        } else {
        }
        if (gridBoxElement) {
          gridBoxElement.__vue__.toggleExpandCollapse(this.expandState);
          // throw Error('Box Widget Parent Not found. Please Put the DBox Component Inside a Valid BoxWidget Component + Inside a Valid Vue Grid Layout Item Component.');
          // return;
        } else {
        }
        // DT Grid Implementation

        // this.$parent.$parent.toggleExpandCollapse(this.expandState);

        // console.log({ "this.expandState": this.expandState });
      }}
      style="margin: 8px; font-weight: inherit; max-width: 180px;"
      class="dt-button v3 c5 txtov"
    >
      {this.expandState ? this.$t(this.collapseButtonLabel) : this.$t(this.expandButtonLabel)}
    </button>);
  };

  syncExpandState() {
    const gridBoxElement = this.$el.closest('div.dt-grid-box');
    if (gridBoxElement) {
      gridBoxElement.__vue__.toggleExpandCollapse(this.expandState);
    }
  }

  render(h) {
    return (
      <div class={`dbox ${this.id}`}>
        {(this.$slots.bottomRight || this.showLeftButton || (this.rightMenu && this.rightMenu.length > 0)) ? (
          <div class="ut-fc ut-fh ut-space-between">
            <div class="ut-fc" style={{
              height: "calc(100% - 48px)",
              overflowY: "auto",
            }}>
              {this.$slots.default}
            </div>
            <div style="display: flex; justify-content: space-between; height: 48px">
              {(this.addLink || this.expandable) ?
                <div class="ut-flex">
                  {this.expandable ? this.showExpandButton(h) : undefined}
                  {this.addLink ? this.showAddLinkButton(h) : undefined}
                </div> : (this.leftMenu && this.leftMenu.length > 0) ? <div class="ut-flex">
                  {this.leftMenu.map(m => this.createLeftMenuButton(h, m))}
                </div> :
                  <div>

                  </div>}


              {this.rightMenu && this.rightMenu.length > 0 ?
                <div class="ut-colcen">
                  <div style="display: flex; justify-content: flex-end">
                    {this.rightMenu.map(m =>

                      <button
                        type='button'

                        class={`dt-button txtov v5${m.type ? m.type : ''} ${m.class ? m.class : ''} s8 ${m.disabled ? 'disabled' : ''}`}
                        style="margin: 8px; margin-left: 5px;"
                        onClick={e => this.onRightMenuClick(m)}
                        disabled={m.disabled}
                        title={m.disabled ? m.disabledTooltip : undefined}
                      >
                        {m.isLoading?
                          <div style="min-width:150px">
                            <img src="static/icons/loading.gif" />
                            
                          </div>
                          : m.text}
                      </button>)}
                  </div>
                </div> : undefined}
              {this.$slots.bottomRight ? <div class="right-menu-slot">
                {this.$slots.bottomRight}
              </div> : undefined}
            </div>
          </div>
        ) : this.$slots.default
        }
        <div class={`dbox-title-bar--options ${this.noSeparator ? 'no_separator' : ''}`}>
          {this.badgeButtons && this.badgeButtons.length > 0 ? <div class="badge-buttons ut-flex">
            {this.badgeButtons.map(m => <button
              type='button'
              class={`dt-button v8${m.type ? m.type : ''} s18p`}
              onClick={e => this.onBadgeClick(m)}
            >
              <div class="btn-bage-text">{m.text}</div>
              {m.icon ? <img
                onKeyUp={e => { }}
                onKeyDown={e => { }}
                onKeyPress={e => { }}
                alt={m.text}
                src={`static/icons/${m.icon}.svg`} style={{
                  // margin: `-2px`,
                  // marginRight: `-3px`,
                  position: "absolute",
                  right: "0",
                  top: "0",
                  width: "19px",
                  height: "19px",
                }} class="dt-icon v5 nohover s0" /> : undefined}
            </button>)}
          </div> : undefined}
          {this.addButton ? this.dboxTitleAddButton(h) : ''}
          {this.searchButton ? this.dboxSearchButton(h) : ''}
          {this.topRightMenu && this.topRightMenu?.length > 0 ? this.topRightMenu.map(m => this.dboxTopRightMenuButton(h, m)) : undefined}
        </div>
      </div >
    );
  }
}
